declare const __TEO_DEFAULT_REVERB_KEY__: string | undefined;
declare const __TEO_DEFAULT_REVERB_HOST__: string | undefined;
declare const __TEO_DEFAULT_REVERB_PORT__: string | undefined;
declare const __TEO_DEFAULT_REVERB_SCHEME__: string | undefined;

function readBaked(value: string | undefined): string {
  try {
    return String(value ?? '').trim();
  } catch {
    return '';
  }
}

/** Reverb defaults baked at loader build time (`VITE_REVERB_*`). */
export function getBakedReverbDefaults(): {
  key: string;
  host: string;
  port: string;
  scheme: string;
} {
  return {
    key: readBaked(
      typeof __TEO_DEFAULT_REVERB_KEY__ !== 'undefined'
        ? __TEO_DEFAULT_REVERB_KEY__
        : undefined,
    ),
    host: readBaked(
      typeof __TEO_DEFAULT_REVERB_HOST__ !== 'undefined'
        ? __TEO_DEFAULT_REVERB_HOST__
        : undefined,
    ),
    port: readBaked(
      typeof __TEO_DEFAULT_REVERB_PORT__ !== 'undefined'
        ? __TEO_DEFAULT_REVERB_PORT__
        : undefined,
    ),
    scheme: readBaked(
      typeof __TEO_DEFAULT_REVERB_SCHEME__ !== 'undefined'
        ? __TEO_DEFAULT_REVERB_SCHEME__
        : undefined,
    ),
  };
}
